<template>
    <div class="comAddress">
        <div class="comAddress_item mb-1 ">
            <div class="comAddress_item_top">
                <div class="comAddress_item_color comAddress_item_weight">{{ $t(title) }}</div>
                <div class='comAddress_item_center'>
                    <div class="mt-0 mr-1 comAddress_item_weight">{{ address }}</div>
                    <img src="@/assets/image/Miracle/personage/copy.png" alt="" class="comAddress_item_img"
                        @click="getcopy(address)">
                </div>
            </div>
            <div class="comAddress_tab_height">
                <div class="comAddress_tab mr-0" v-for="item in tabList">
                    {{ item.value }}
                </div>
            </div>

        </div>

    </div>
</template>

<script>
export default {
    name: 'ComAddress',
    props: {
        tabList: {
            type: Array,
            default: []
        },
        title: {
            type: String,
            default: ''
        },
        address: {
            type: String,
            default: ''
        }

    },
    data() {
        return {

        }
    },
    methods: {
        getcopy(data) {
            this.$emit('copy', data)
        }
    }
}
</script>

<style  lang="scss" scoped >
@import './index.scss';
</style>